/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { ApmRoute } from '@elastic/apm-rum-react';
import { RouteType } from '.';
import Template from '../template';

export const NestedRoutesWithMenu = ({
  routes,
}: {
  routes: { [key: string]: RouteType };
}) => (
  <Template>
    <Switch>
      {Object.keys(routes).map((key: string) => {
        const { path, component: Component, redirectTo } = routes[key];
        if (Component) {
          return (
            <ApmRoute
              key={`AppRoute-${key}`}
              path={path}
              component={Component}
            />
          );
        }

        if (redirectTo) {
          return (
            <Redirect key={`AppRoute-${key}`} path={path} to={redirectTo} />
          );
        }
      })}
    </Switch>
  </Template>
);

export default NestedRoutesWithMenu;
